import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import KeyboardDoubleArrowLeftIcon from "@mui/icons-material/KeyboardDoubleArrowLeft";
import KeyboardDoubleArrowRightIcon from "@mui/icons-material/KeyboardDoubleArrowRight";
import { Pagination as MuiPagination, PaginationItem } from "@mui/material";
import TextField from "components/TextField";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate, useSearchParams } from "react-router-dom";
import RightToLeftLayout from "../RightToLeft";
import classes from "./style.module.scss";

export const Pagination = ({ count, pageParamName = "page", className = "" }) => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const page = searchParams.get(pageParamName) ?? 1;
  const { watch, control, handleSubmit } = useForm({
    mode: "onChange",
    defaultValues: {
      page: page,
    },
  });

  const [currentPage, setCurrentPage] = useState(1);

  const handlePageChange = (_, value) => {
    const params = new URLSearchParams(searchParams.toString());
    params.set(pageParamName, value.toString());
    navigate(`?${params.toString()}`);
  };
  const onSubmit = (data) => {
    handlePageChange(null, data?.page);
  };

  useEffect(() => {
    setCurrentPage(Number(page));
  }, [page]);

  return (
    <RightToLeftLayout>
      <form onSubmit={handleSubmit(onSubmit)} className={classes.paginationBox}>
        <TextField
          name="page"
          control={control}
          label="شماره صفحه"
          number
          className={classes.pageFilter}
          fullWidth={false}
        />

        <MuiPagination
          className={`${className} ${classes.mainComponent}`}
          count={count}
          showFirstButton
          showLastButton
          page={currentPage}
          onChange={handlePageChange}
          color="primary"
          renderItem={(item) => (
            <PaginationItem
              slots={{
                first: KeyboardDoubleArrowLeftIcon,
                previous: KeyboardArrowLeftIcon,
                next: KeyboardArrowRightIcon,
                last: KeyboardDoubleArrowRightIcon,
              }}
              {...item}
            />
          )}
        />
      </form>
    </RightToLeftLayout>
  );
};
